import React, { memo } from 'react';

// styles
import { Info } from './styles';

interface Props {
  isOutOfStock: boolean;
  stockRemaining?: number;
}

const SOLD_OUT = 'sold out';
const STOCK_LEFT_TEXT = 'left';

function StockInfo({ isOutOfStock, stockRemaining }: Props) {
  if (isOutOfStock) {
    return <Info isOutOfStock={isOutOfStock}>{SOLD_OUT}</Info>;
  }

  if (stockRemaining) {
    return (
      <Info>
        {stockRemaining}&nbsp;{STOCK_LEFT_TEXT}
      </Info>
    );
  }

  return null;
}

export default memo(StockInfo);
